import { usePrivy, useWallets } from '@privy-io/react-auth';
import { useEffect, useState } from 'react';
import { getPreferredWalletAddress } from '../utils/wallet';

interface KingsomniUser {
  address?: string;
  username?: string;
  hasUsername: boolean;
  isLoading: boolean;
  error?: string;
}

export function useKingsomniUser() {
  const { user, authenticated, ready } = usePrivy();
  const { wallets } = useWallets();
  const [userState, setUserState] = useState<KingsomniUser>({
    isLoading: true,
    hasUsername: false,
  });

  useEffect(() => {
    if (!ready) return;

    const fetchUserData = async () => {
      try {
        const address = getPreferredWalletAddress(wallets) || user?.wallet?.address;
        if (!authenticated || !address) {
          setUserState({
            isLoading: false,
            hasUsername: false,
          });
          return;
        }

        // Username flow is disabled for Somnia mode.
        // Keep hasUsername=true so gameplay is not blocked by profile modal.
        setUserState({
          isLoading: false,
          address,
          hasUsername: true,
        });
      } catch (error) {
        console.error('useKingsomniUser Error:', error);
        setUserState({
          isLoading: false,
          hasUsername: false,
          error: error instanceof Error ? error.message : 'Unknown error',
        });
      }
    };

    fetchUserData();
  }, [user, authenticated, ready, wallets]);

  return userState;
}
